import { ICreateProjetoRevisaoResumoUseCase } from "../../../presentation/useCases/create/create_projeto_revisao_resumo_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";

export class CreateProjetoRevisaoResumoUseCase implements ICreateProjetoRevisaoResumoUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async createProjetoRevisaoResumo(idProjeto: number | null,       
  idDisciplina: number | null,    
  descricao: string | null,       
  responsavel: string | null,     
  idFuncionario: number | null,   
  data: Date | null): Promise<void> {
    await this.repository.createProjetoRevisaoResumo(idProjeto,idDisciplina, descricao, responsavel, idFuncionario, data);
  }
}
